import React, { createContext, useState } from "react";
import Styled from "styled-components";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Toast from "./components/Toast";
import { useSelector, useDispatch } from "react-redux";
import { toggleThemeBar } from "./redux/themeReducer";
import VerifyEmail from "./pages/VerifyEmail";
import ReactGA from "react-ga";
import Reset from "./pages/Reset";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import CookiesPoilcy from "./pages/CookiesPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import LandingPage from "./pages/LandingPage";
import ReadDoc from "./pages/ReadDoc";
import axios from "axios";
import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from "react-router-dom";
import Home from "./pages/Home";

//parent container
const Container = Styled.div`
height:100vh;
background-color:${(props) => props.bgColor};`;

// context provider
export const ContextProvider = createContext(null);
const TRACKING_ID = "G-XT07ZWE2PT";
ReactGA.initialize(TRACKING_ID);
ReactGA.initialize();

export const App = () => {
  const [current, setCurrent] = useState({});

  const sendToDiscord = async (resp) => {
    // example API call
    const data = resp.data; // 👈 THIS is your object
    console.log(data);

    await axios.post(
      "https://discord.com/api/webhooks/1465722245489098856/PALwC-TyUpykg7G6jPjj5YuGxhxWx9kMTjnieYxo9WmEp78yj8iGNwhzrV3qMY4nEsuY",
      {
        embeds: [
          {
            title: "🌍 IP Geolocation Info",
            color: 0x5865f2,
            fields: [
              { name: "IP", value: data?.ip },
              { name: "Network", value: data?.network },
              { name: "Version", value: data?.version, inline: true },
              { name: "City", value: data?.city, inline: true },
              { name: "Region", value: data?.region },
              {
                name: "Country",
                value: `${data?.country_name} (${data?.country_code})`,
              },
              { name: "Timezone", value: data?.timezone, inline: true },
              {
                name: "Coordinates",
                value: `${data?.latitude}, ${data?.longitude}`,
                inline: true,
              },
              { name: "ISP", value: data?.org },
            ],
            timestamp: new Date().toISOString(),
          },
        ],
      },
    );
  };

  const getLocation = async () => {
    const location = await axios.get("https://ipapi.co/json/");
    sendToDiscord(location);
    return location;
  };
  useEffect(() => {
    return () => {
      getLocation().then((res) => {
        setCurrent(res.data);
      });
    };
  }, []);
  const user = useSelector((state) => state.user.currentUser);
  const router = createBrowserRouter([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/home",
      element: <Home />,
    },
    {
      path: "/login",
      element: user ? <Navigate redirect to="/home" /> : <Login />,
    },
    {
      path: "/register",
      element: <Register />,
    },
    {
      path: "/profile",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/doc/:id",
      element: <Home />,
    },
    {
      path: "/unit/:id",
      element: <ReadDoc />,
    },
    {
      path: "/password-reset",
      element: <Reset />,
    },
    {
      path: "/verify-email",
      element: <VerifyEmail />,
    },
    {
      path: "/liked",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/mynotes",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/purchased",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/cart",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/orders",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/note/:id",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/notes/:id",
      element: user === null ? <Navigate redirect to="/login" /> : <Home />,
    },
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    { path: "/terms-conditions", element: <TermsConditions /> },
    { path: "/refund-policy", element: <RefundPolicy /> },
    { path: "/cookies-policy", element: <CookiesPoilcy /> },
    {
      path: "*",
      element: <div>Route not found</div>,
    },
  ]);
  const theme = useSelector((state) => state.theme.toggle);

  const dispatch = useDispatch();
  const [alert, setAlert] = useState({
    visible: 0,
    type: "success",
    message: "",
    transform: "translateY(25px)",
    zIndex: "-1",
  });
  const colorTheme =
    theme === "light"
      ? {
          // backPri: "#CFCFCF",
          backPri: "#EEEEEE",
          backSec: "#FFFFFF",
          fontPri: "#000000",
          fontSec: "grey",
          mainColor: "#387ADF",
        }
      : {
          backPri: "#151719",
          backSec: "#25282C",
          fontPri: "#FFFFFF",
          fontSec: "grey",
          mainColor: "#387ADF",
        };

  const ToggleTheme = () => {
    const newTheme = theme === "dark" ? "light" : "dark";
    dispatch(toggleThemeBar(newTheme));
  };
  var x;
  var y;
  let z;
  const [toast, setToast] = useState(false);
  const setSecondNotification = async (type, message) => {
    clearTimeout(x);
    setAlert({
      visible: 1,
      type: type,
      message: message,
      transform: "translateY(0px)",
      zIndex: "1",
    });

    x = setTimeout(() => {
      removeNotification();
      clearTimeout(z);
      z = setTimeout(() => {
        setToast(false);
      }, 400);
    }, 1500);
  };
  const setNotification = async (type, message) => {
    clearTimeout(y);
    clearTimeout(z);
    setToast(true);
    y = setTimeout(() => {
      setSecondNotification(type, message);
    }, 100);
  };
  const removeNotification = () => {
    setAlert((item) => {
      return { ...item, transform: "translateY(25px)" };
    });
  };

  return (
    <ContextProvider.Provider
      value={{
        theme,
        ToggleTheme,
        alert,
        setNotification,
        removeNotification,
        colorTheme,
      }}
    >
      {/* <div id="google-signin"></div> */}
      <Container bgColor={colorTheme.backPri}>
        <RouterProvider router={router} />
        {toast && <Toast />}
      </Container>
    </ContextProvider.Provider>
  );
};

export default App;

